/* tslint:disable */
/* eslint-disable */
/* @relayHash 93939fa60bb0997b6b5423fe0754656c */

import { ConcreteRequest } from "relay-runtime";
export type SimulatorCardQueryVariables = {
    uuid: string;
    startDate: string;
    endDate: string;
};
export type SimulatorCardQueryResponse = {
    readonly delegate: {
        readonly simulator: {
            readonly compliance: {
                readonly compliant: boolean;
                readonly minsCompleted: number;
                readonly requiredMins: number;
                readonly startDate: string;
                readonly successRate: number;
                readonly imagesSeen: number;
            };
        } | null;
    } | null;
};
export type SimulatorCardQuery = {
    readonly response: SimulatorCardQueryResponse;
    readonly variables: SimulatorCardQueryVariables;
};



/*
query SimulatorCardQuery(
  $uuid: UUID!
  $startDate: Time!
  $endDate: Time!
) {
  delegate(uuid: $uuid) {
    simulator {
      compliance(startDate: $startDate, endDate: $endDate) {
        compliant
        minsCompleted
        requiredMins
        startDate
        successRate
        imagesSeen
      }
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "uuid",
            "type": "UUID!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "startDate",
            "type": "Time!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "endDate",
            "type": "Time!",
            "defaultValue": null
        } as any)
    ], v1 = [
        ({
            "kind": "LinkedField",
            "alias": null,
            "name": "delegate",
            "storageKey": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "uuid",
                    "variableName": "uuid"
                }
            ],
            "concreteType": "Delegate",
            "plural": false,
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "simulator",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Simulator",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "compliance",
                            "storageKey": null,
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "endDate",
                                    "variableName": "endDate"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "startDate",
                                    "variableName": "startDate"
                                }
                            ],
                            "concreteType": "SimulatorUserData",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "compliant",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "minsCompleted",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "requiredMins",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "startDate",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "successRate",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "imagesSeen",
                                    "args": null,
                                    "storageKey": null
                                }
                            ]
                        }
                    ]
                }
            ]
        } as any)
    ];
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "SimulatorCardQuery",
            "type": "Query",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v1 /*: any*/)
        },
        "operation": {
            "kind": "Operation",
            "name": "SimulatorCardQuery",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v1 /*: any*/)
        },
        "params": {
            "operationKind": "query",
            "name": "SimulatorCardQuery",
            "id": null,
            "text": "query SimulatorCardQuery(\n  $uuid: UUID!\n  $startDate: Time!\n  $endDate: Time!\n) {\n  delegate(uuid: $uuid) {\n    simulator {\n      compliance(startDate: $startDate, endDate: $endDate) {\n        compliant\n        minsCompleted\n        requiredMins\n        startDate\n        successRate\n        imagesSeen\n      }\n    }\n  }\n}\n",
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = 'b9f73a5bf598a8d6d738242b8b2e856c';
export default node;
